<template>
    <div style="animation: rotation 5s infinite linear;">
        <Animation
            ref="anim"
            :animation-data="animationLoopData"
            auto-play
            loop
            :speed="speed"
            @loopComplete="onComplete"
        />
    </div>
</template>

<script>
import Animation from "@/components/Animation/Index";
import { ref } from "@vue/composition-api";
import animationIntroData from '@/assets/animations/UkuLoadingIntroExport.json';
import animationLoopData from '@/assets/animations/UkuLoadingLoopExport.json';

export default {
    name: "LoaderAnimation",
    components: {
        Animation
    },
    setup() {
        const anim = ref(null);
        const speed = ref(1);

        const onComplete = () => {
            speed.value = 0.1;
        }

        return {
            animationIntroData,
            animationLoopData,
            onComplete,
            anim,
            speed
        };
    }
};
</script>
